import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Key-Value Storage/index.md";
import * as React from 'react';
export default {
  Content,
  React
};